import { TabsWrapper, PillWrapper } from '@nkr/views/invoice/styles';

interface IProps {
    subTabKey: string;
}

const Tabs = (props: IProps) => {
    return (
        <TabsWrapper className='xtabs' style={{ paddingTop: 0 }}>
            <ul className='nav nav-tabs' style={{ marginBottom: 0 }}>
                <li className='active'><a href={'/admin/voucher-book'}><span>Voucher Book</span></a></li>
            </ul>

            <div className='nav nav-tabs' style={{ backgroundColor: '#ccc', paddingTop: 5, paddingLeft: 5 }}>
                <PillWrapper className={props.subTabKey == 'GENERATE' ? 'on' : ''}>
                    <a href={'/admin/voucher-book'}>
                        <span>Generate</span>
                    </a>
                </PillWrapper>
            </div>
        </TabsWrapper>
    );
}

export default Tabs;
